import Quick from './Quick'

export default Quick
